import { Injectable, signal, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

const THEME_STORAGE_KEY = 'ng_audit_theme';
const THEME_CLASSES = ['dark-mode', 'sky-blue-mode', 'high-contrast-green-mode', 'purple-mode'];

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private document = inject(DOCUMENT);

  readonly $theme = signal<string>('light');

  constructor() {
    this.loadTheme();
  }

  loadTheme(): void {
    const saved = localStorage.getItem(THEME_STORAGE_KEY) || 'light';
    this.setTheme(saved);
  }

  setTheme(theme: string): void {
    this.$theme.set(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);

    const body = this.document.body;
    body.classList.remove(...THEME_CLASSES);
    if (theme !== 'light') {
      body.classList.add(`${theme}-mode`);
    }
  }

  isDarkMode(): boolean {
    return this.$theme() === 'dark';
  }
}
